// extracted by mini-css-extract-plugin
export var container = "notification-module--container--81831";